export const variantMapping = {
  small: {
    backgroundColor: '#007AFF',
    thumbColor: '#007AFF',
    trackBackground: '#E9E9EA',
    width: 28,
    height: 16,
    thumbWidth: 12,
    thumbHeight: 12,
    // Quãng chạy của núm: rộng - núm - lề hai bên.
    translateX: 12,
    borderRadius: 100,
  },
  ios: {
    backgroundColor: '#65C466',
    thumbColor: '#65C466',
    trackBackground: '#E9E9EA',
    width: 40,
    height: 24,
    thumbWidth: 20,
    thumbHeight: 20,
    translateX: 16,
    borderRadius: 100,
  },
};
